// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"c08345f0","147":"89c67b1e","309":"30263d38","325":"9965456d","855":"58bf862f","958":"402f7497","980":"9609159f"}[chunkId] + ".chunk.css";
};